<template>
  <div class="bg-gradient-to-br from-accent-500 to-teal-600 rounded-2xl p-8 md:p-12 text-center text-white relative overflow-hidden">
    <div class="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
    <div class="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2" />

    <div class="relative z-10">
      <component :is="headingTag" class="text-3xl font-bold mb-4">
        {{ title }}
      </component>
      <p v-if="description" class="text-white/80 text-lg mb-8 max-w-xl mx-auto">
        {{ description }}
      </p>
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  headingTag: {
    type: String,
    default: 'h2',
    validator: (v) => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(v)
  }
})
</script>
